module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedBlack.809fdf2.woff";